import axios from 'axios'
import Qs from 'qs'
import Cookie from 'js-cookie'

export const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  paramsSerializer: function(params) {
    return Qs.stringify(params, { arrayFormat: 'brackets' })
  },
})

http.interceptors.request.use(config => {
  const csrfToken = Cookie.get('intranet_csrf_token') || null
  config.headers['X-CSRF-Token'] = csrfToken
  return config
})

http.interceptors.response.use(
  response => response,
  error => {
    // We really want to throw the error so it is handled and we don't get
    // an unhandledrejection error. By throwing here, we are handling the
    // rejection, and bubbling up to the closest error handler (try/catch or
    // catch method call on a promise).
    const status = error.response ? error.response.status : null
    if (status === 403) {
      const loc = location || window.location
      loc.href = loc.origin + loc.pathname + loc.search
    }
    throw error
  },
)

export const http_billing = axios.create({
  baseURL: process.env.VUE_APP_BILLING_API_URL,
  paramsSerializer: function(params) {
    return Qs.stringify(params, { arrayFormat: 'brackets' })
  },
})

http_billing.interceptors.response.use(
  response => response,
  error => {
    throw error
  },
)
